var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2006 2.64829C14.0144 1.83448 15.1228 1.37305 16.2768 1.37305C18.6801 1.37305 20.6283 3.32128 20.6283 5.72454C20.6283 6.87861 20.1669 7.98698 19.3531 8.80079L15.675 12.4789C14.8612 13.2927 13.7528 13.7542 12.5987 13.7542C11.4 13.7542 10.3101 13.2665 9.52246 12.4789L10.175 11.8264C10.7967 12.4482 11.6547 12.8314 12.5987 12.8314C13.5071 12.8314 14.3811 12.4678 15.0225 11.8264L18.7006 8.14829C19.342 7.50689 19.7056 6.63297 19.7056 5.72454C19.7056 3.83092 18.1705 2.29582 16.2768 2.29582C15.3684 2.29582 14.4945 2.65939 13.8531 3.30079L10.5932 6.56069L9.94069 5.90818L13.2006 2.64829Z",
    fill: "#B41730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32544 9.52329C7.13925 8.70948 8.24762 8.24805 9.40169 8.24805C10.6004 8.24805 11.6903 8.73566 12.4779 9.52329L11.8254 10.1758C11.2037 9.55405 10.3457 9.17082 9.40169 9.17082C8.49326 9.17082 7.61934 9.53439 6.97794 10.1758L3.29981 13.8539C2.65842 14.4953 2.29485 15.3692 2.29485 16.2777C2.29485 18.1713 3.82994 19.7064 5.72356 19.7064C6.63199 19.7064 7.50592 19.3428 8.14731 18.7014L11.4072 15.4415L12.0597 16.094L8.79981 19.3539C7.986 20.1677 6.87763 20.6292 5.72356 20.6292C3.32031 20.6292 1.37207 18.6809 1.37207 16.2777C1.37207 15.1236 1.8335 14.0152 2.64731 13.2014L6.32544 9.52329Z",
    fill: "#B41730"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedLink);
export default __webpack_public_path__ + "static/media/red_link.263557c7.svg";
export { ForwardRef as ReactComponent };